import { render, staticRenderFns } from "./ManagePresetsModal.vue?vue&type=template&id=6dc95450&scoped=true&"
import script from "./ManagePresetsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ManagePresetsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc95450",
  null
  
)

export default component.exports